const memoryCache = new Map();

const stableRequestString = request => [
    request.text || '',
    request.language || 'english',
    request.style || 'Normal',
    Number(request.speed || 1).toFixed(2)
].join('|');

const fallbackHash = value => {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = ((hash << 5) - hash) + value.charCodeAt(i);
        hash |= 0;
    }
    return `tts2-${Math.abs(hash)}`;
};

const toHex = buffer => Array.prototype.map.call(
    new Uint8Array(buffer),
    byte => byte.toString(16).padStart(2, '0')
).join('');

const createCacheKey = async request => {
    const value = stableRequestString(request);
    if (window.crypto && window.crypto.subtle && window.TextEncoder) {
        const data = new TextEncoder().encode(value);
        const digest = await window.crypto.subtle.digest('SHA-256', data);
        return toHex(digest);
    }
    return fallbackHash(value);
};

const getCachedAudioUrl = key => memoryCache.get(key);

const setCachedAudioUrl = (key, audioUrl) => {
    if (key && audioUrl) {
        memoryCache.set(key, audioUrl);
    }
};

export {
    createCacheKey,
    getCachedAudioUrl,
    setCachedAudioUrl
};
